const TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX = /[ .,;!?'‘’“”\-–—]+$/
const ELLIPSIS_CHARACTER = '\u2026'

function truncateTextNode( textNode, rootElement, maximumHeight, ellipsisCharacter, element) {
  let lastIndexOfWhitespace
  let textContent = textNode.textContent

  while (textContent.length > 1) {
    lastIndexOfWhitespace = textContent.lastIndexOf(' ')
    if (lastIndexOfWhitespace === -1) break


    textNode.textContent = textContent.substring(0, lastIndexOfWhitespace)

    if (rootElement.scrollHeight <= maximumHeight) {
      textNode.textContent = textContent
      break
    }

    textContent = textNode.textContent
  }

  return truncateTextNodeByCharacter( textNode, rootElement, maximumHeight, ellipsisCharacter, element)
}

function truncateTextNodeByCharacter( textNode, rootElement, maximumHeight, ellipsisCharacter, element) {
  let textContent = textNode.textContent
  let length = textContent.length


  while (length > 1) {
    textContent = textContent.substring(0, length - 1).replace(TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX, '')
    length = textContent.length

    textNode.textContent = textContent + '...'

    if (rootElement.scrollHeight <= maximumHeight) {

      if (!element.querySelector('.dy-max-button')) {
        const button = document.createElement('button')
        button.className = 'dy-max-button'
        button.type = 'button'
        button.textContent = ellipsisCharacter
        element.appendChild(button)
      }

      return true
    }
  }

  return false
}

function truncateElementNode(element, rootElement, maximumHeight, ellipsisCharacter) {
  const childNodes = element.childNodes
  let i = childNodes.length - 1


  while (i > -1) {
    const childNode = childNodes[i--]
    const nodeType = childNode.nodeType

    if((nodeType === 1 &&  truncateElementNode(childNode, rootElement, maximumHeight, ellipsisCharacter)) || (nodeType === 3 && truncateTextNode( childNode, rootElement,  maximumHeight,  ellipsisCharacter, element))) return true

    element.removeChild(childNode)
  }

  return false
}

type TypeClampOptions = {
  ellipsis?: string
}
export const clamp = function (rootElement, maximumHeight, options: TypeClampOptions = {}) {
  rootElement.style.cssText += 'overflow:hidden;overflow-wrap:break-word;word-wrap:break-word'

  if (rootElement.scrollHeight <= maximumHeight) return false

  const result = truncateElementNode(rootElement,rootElement, maximumHeight,(options && options.ellipsis) || ELLIPSIS_CHARACTER)

  return result
}
